export const NO_RESULTS_OPTIONS = [
  { value: null, text: 'No results match your search', isDisabled: true }
];

export const PLACEHOLDER_OPTIONS = [
  { value: null, text: 'Type 2 symbols above to search', isDisabled: true }
];
